import React from "react";
import TabbedPage from "../shared/TabbedPage";
import translate from "../../../../i18n/translate";
import MintRoutContainer from "../MintRouteContainer";
import HyperMediaSettingsContainer from "../HypermediaSettingsContainer";
import PubgSettings from "components/pages/settings/PubgSettings";
import GetSettings from "components/pages/settings/IsrealCompanies/IsraelSettings";

// Gift card and game suppliers.
const GiftCardsPage = ({ defaultTab }) => (
  <TabbedPage
    id="giftcards"
    title={translate("Gift cards & games")}
    intro={translate("giftCardsHint")}
    defaultTab={defaultTab}
    tabs={[
      { key: "mintroute", label: "Mintroute", render: () => <MintRoutContainer /> },
      { key: "hypermedia", label: translate("Hypermedia"), render: () => <HyperMediaSettingsContainer /> },
      { key: "gemzo", label: translate("gemzo"), render: () => <GetSettings carrier="gemzo" /> },
      { key: "pubg", label: "PUBG", render: () => <PubgSettings /> },
    ]}
  />
);

export default GiftCardsPage;
